export default "__VITE_ASSET__YNC0FCxj__"